import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DefaultButton from '../buttons/default-btn/DefaultButton';
import './Footer.scss';
import LabelText from '../product-label/ProductLabel';
import LocalizedText from '@LocalizedText';
import { WHITE_INK_OPTIONS_VIEW } from '@app/constants';
import { isMobileMode } from '@app/utils/utils';
import { setFooterConfig } from '@app/actions/footerActions';

const Footer = ({
  onBack = () => {},
  onNext = () => {},
  visible,
  backHidden,
  nextHidden,
  backDisabled,
  nextDisabled,
  nextLocKey = 'qau-next-btn',
  backLocKey = 'qau-back-btn',
  customClassName = '',
  showProductLabel,
  noteMessageLocKey,
  saveToYourAccount,
  isMobileMode,
  setFooterConfig,
  showSaveToMyAccount,
}) =>
  visible && (
    <div id="qau-footer" data-testid="qau-footer" className={customClassName}>
      <DefaultButton id="footer-back-btn" locKey={backLocKey} disabled={backDisabled} hidden={backHidden} onClick={onBack} secondary />
      {showProductLabel && <LabelText />}
      {noteMessageLocKey && <LocalizedText id={noteMessageLocKey} tagName="span" />}

      <div className="next-btn-container">
        {showSaveToMyAccount && !isMobileMode && !nextHidden && (
          <label htmlFor="save-to-your-account" className="save-to-account">
            <input
              type="checkbox"
              id="save-to-your-account"
              data-testid="save-to-your-account"
              onChange={() => setFooterConfig({ saveToYourAccount: !saveToYourAccount })}
              checked={saveToYourAccount}
            />
            <LocalizedText id="qau-save-to-your-account" tagName="span" />
          </label>
        )}
        <DefaultButton id="footer-next-btn" locKey={nextLocKey} disabled={nextDisabled} hidden={nextHidden} onClick={onNext} />
      </div>
    </div>
  );

Footer.propTypes = {
  setFooterConfig: PropTypes.func,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  backHidden: PropTypes.bool,
  nextHidden: PropTypes.bool,
  backDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  nextLocKey: PropTypes.string,
  backLocKey: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  customClassName: PropTypes.string,
  showProductLabel: PropTypes.bool,
  noteMessageLocKey: PropTypes.string,
  showSaveToMyAccount: PropTypes.bool,
  isMobileMode: PropTypes.bool,
  saveToYourAccount: PropTypes.bool,
};

const mapStateToProps = ({ footer, matrix: { view, ctx } }) => ({
  onBack: footer.onBack,
  onNext: footer.onNext,
  visible: footer.visible,
  backHidden: footer.backHidden,
  nextHidden: footer.nextHidden,
  nextLocKey: footer.nextLocKey,
  backLocKey: footer.backLocKey,
  backDisabled: footer.backDisabled,
  nextDisabled: footer.nextDisabled,
  customClassName: footer.customClassName,
  showProductLabel: [WHITE_INK_OPTIONS_VIEW].includes(view),
  noteMessageLocKey: footer.noteMessageLocKey,
  saveToYourAccount: footer.saveToYourAccount,
  showSaveToMyAccount: footer.showSaveToMyAccount,
  isMobileMode: isMobileMode(ctx),
});
const mapDispatchToProps = { setFooterConfig };

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
